import React from 'react';
import { Switch, Dropdown, Tooltip } from 'antd';
import { More, WarmingCircle } from 'patternx-svg';
import './index.less';
import classNames from 'classnames';

interface IData {
  id: string;
  name: string;
  checked?: boolean | undefined;
  disableChecked?: boolean;
  isNew?: boolean | undefined;
  errorMessage?: boolean;
  [key: string]: any;
}

interface AttributeListProps {
  data: IData[];
  selectedKey?: string;
  dropdownOverlay?: (record: IData) => React.ReactElement;
  onChecked: (record: IData, checked: boolean) => void;
  onSelect: (record: IData) => void;
}

const AttributeList: React.FC<AttributeListProps> = (props) => {
  const { data, selectedKey, dropdownOverlay, onChecked, onSelect } = props;

  const handleClick = (e: React.MouseEvent, record: IData) => {
    e.stopPropagation();
    if ((record.id || 'new') === selectedKey) {
      return;
    }
    onSelect(record);
  };

  return (
    <div className="attribute-list">
      <div className="attribute-content">
        {data?.map((item) => (
          <div
            key={item.id || 'new'}
            className={classNames('attribute-item', {
              'attribute-item-active': selectedKey && selectedKey === item.id,
            })}
          >
            <span className="attribute-item-name" onClick={(e) => handleClick(e, item)}>
              {item.name}
            </span>
            {!item.isNew && item.id && (
              <div className="attribute-item-operate" onClick={(event) => event.stopPropagation()}>
                {item?.errorMessage && (
                  <Tooltip placement="top" title={item.errorMessage}>
                    <WarmingCircle size={20} className="operate-error" />
                  </Tooltip>
                )}

                <Tooltip placement="top" title={item.checked ? '已发布' : '未发布'}>
                  <Switch
                    checked={!!item.checked}
                    disabled={!!item.disableChecked}
                    onChange={(checked) => onChecked(item, checked)}
                  />
                </Tooltip>

                {dropdownOverlay && (
                  <Dropdown trigger={['click']} overlay={() => dropdownOverlay(item)}>
                    <More className="operate-more" />
                  </Dropdown>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AttributeList;
